import { useMutation, useQuery } from '@apollo/client'
import React, { useEffect, useRef, useState } from 'react'
import {
  EXPORT_ALL_LOGS_EMPLOYEES,
  EXPORT_ALL_LOGS_EMPLOYEES_BY_EMPLOYEE_ID,
  GET_ALL_LOGS_EMPLOYEES,
  GET_CHECK_TYPES,
  GET_LOG_STATUSES,
} from '../../../../../graphql/Catalog/Employees/Logs/employeeLogs'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../../Global/LayoutTable'
import moment from 'moment'
import ModalContent from '../../../../Global/ModalContent'
import DetailsEmployeeLog from './components/DetailsEmployeeLog'
import FormJustification from './components/FormJustification'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import { CSVLink } from 'react-csv'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import ContentHeader from '../../../../Layout/ContentHeader'
const MySwal = withReactContent(Swal)

const EmployeesLogs = () => {
  const refModal = useRef(null)
  const { showLoading, hideLoading } = useLoading()
  const [layoutInformation, setLayoutInformation] = useState({
    dataTable: [],
    totalCount: 0,
  })
  const [pagePagination, setPagePagination] = useState({
    searchQuery: '',
    limit: 10,
    offset: 0,
    filters: {
      employee_id: null,
      check_type: null,
      log_status: null,
      start_date: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      end_date: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    },
  })
  const [modalContent, setModalContent] = useState({
    modalId: false,
    title: '',
    content: null,
    size: 'extra',
  })
  const [exportationData, setExportationData] = useState({
    filename: 'registros_empleados',
    dataToExport: [],
  })
  const [options, setOptions] = useState({
    checkType: [],
    logStatus: [],
  })
  const [closeModal, setCloseModal] = useState(false)

  const { loading, error, data, refetch } = useQuery(GET_ALL_LOGS_EMPLOYEES, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      filters: pagePagination.filters,
    },
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingTypes,
    error: errorTypes,
    data: dataTypes,
  } = useQuery(GET_CHECK_TYPES, {
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingStatus,
    error: errorStatus,
    data: dataStatus,
  } = useQuery(GET_LOG_STATUSES, {
    fetchPolicy: 'cache-and-network',
  })

  const [exportAllLogs] = useMutation(EXPORT_ALL_LOGS_EMPLOYEES)
  const [exportLogsByEmployeeId] = useMutation(
    EXPORT_ALL_LOGS_EMPLOYEES_BY_EMPLOYEE_ID
  )

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw new Error(error.message)
      const { getAllEmployeeLogs } = data

      const { count, rows } = getAllEmployeeLogs

      const list = rows.map((item) => {
        return {
          id: item.id,
          Nombre: `${item.EmployeeLogsToEmployee.first_name} ${item.EmployeeLogsToEmployee.last_name}`,
          fecha: moment(item.check_date).format('dddd, D [de] MMMM [de] YYYY'),
          'tipo de registro': item.check_type,
          hora: moment(item.check_date).format('hh:mm a'),
          retardo:
            item.check_type === 'entrada'
              ? `${getMinutesFromDateTime(item.lateness_time)}(
                ${moment(item.lateness_time, 'HH:mm:ss').format('HH:mm')}
                )`
              : 'N/A',
          'salida temprana':
            item.check_type === 'salida'
              ? `${getMinutesFromDateTime(item.left_early_time)}(
                ${moment(item.left_early_time, 'HH:mm:ss').format('HH:mm')}
              )`
              : 'N/A',
          'estado del registro': item.log_status,

          justificante: item.EmployeeLogsToJustification
            ? item.EmployeeLogsToJustification.justification_type_spanish
            : 'N/A',
          justificante:
            item.check_type === 'ausencia' &&
            !item.EmployeeLogsToJustification ? (
              <button
                className="btn btn-orange btn-sm"
                onClick={() => handleCreateJustification(item.id, item)}
              >
                Justificar
              </button>
            ) : item.check_type === 'ausencia' &&
              item.EmployeeLogsToJustification ? (
              <button
                className="btn btn-orange btn-sm"
                onClick={() => handleUpdateJustification(item, item.id)}
              >
                Justificado
              </button>
            ) : (
              ''
            ),
          item__omit: item,
        }
      })

      setLayoutInformation({
        dataTable: list,
        totalCount: count,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  useEffect(() => {
    if (closeModal) {
      setModalContent({
        modalId: false,
        title: '',
        content: null,
        size: 'extra',
      })
      refModal.current.click()
      setCloseModal(false)
    }
  }, [closeModal])

  useEffect(() => {
    if (modalContent.modalId) {
      document.getElementById(`spanModal${modalContent.modalId}`).click()
    }
  }, [modalContent])

  useEffect(() => {
    if (exportationData.dataToExport.length > 0) {
      document.getElementById('exportLogsEmployees').click()
    }
  }, [exportationData])

  useEffect(() => {
    try {
      if (loadingTypes) return
      if (errorTypes) throw new Error(errorTypes.message)

      setOptions((prev) => ({
        ...prev,
        checkType: dataTypes.getCheckTypes,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingTypes, errorTypes, dataTypes])

  useEffect(() => {
    try {
      if (loadingStatus) return
      if (errorStatus) throw new Error(errorStatus.message)
      setOptions((prev) => ({
        ...prev,
        logStatus: dataStatus.getLogStatuses,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingStatus, errorStatus, dataStatus])

  const getMinutesFromDateTime = (dateTime) => {
    const time = moment(dateTime, 'HH:mm:ss')
    return `${time.hours() * 60 + time.minutes()} minutos`
  }

  const handleFiltersDateRange = (e, field) => {
    console.log('field', field, 'e', e.target.value)
    const newField = field === 'from' ? 'start_date' : 'end_date'
    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [newField]:
          newField === 'start_date'
            ? moment(e.target.value)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss')
            : moment(e.target.value).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      },
    }))
  }

  const handleFilters = (e, field) => {
    console.log('field', field, 'e', e)
    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [field]: e ? e.value : null,
      },
    }))
  }

  const handleDetails = (row, id) => {
    setModalContent({
      modalId: `modalDetails${id}`,
      title: `Detalles del registro de ${row.item__omit.check_type} ${row.Nombre} - ${row.fecha}`,
      content: (
        <DetailsEmployeeLog
          item={row.item__omit}
          setCloseModal={setCloseModal}
          getMinutesFunction={getMinutesFromDateTime}
        />
      ),
      size: 'extra',
    })
  }

  const handleCreateJustification = (id, row) => {
    setModalContent({
      modalId: `modalCreateJustification${id}`,
      title: `Crear justificante para ${
        row.EmployeeLogsToEmployee.first_name
      } ${row.EmployeeLogsToEmployee.last_name} - ${moment(
        row.check_date
      ).format('dddd, D [de] MMMM [de] YYYY')}`,
      content: (
        <FormJustification
          item={row}
          setCloseModal={setCloseModal}
          getMinutesFunction={getMinutesFromDateTime}
          logId={id}
          refetchLogs={refetch}
        />
      ),
      size: 'large',
    })
  }

  const handleUpdateJustification = (row, id) => {
    console.log('id', id, 'row', row)
    setModalContent({
      modalId: `modalUpdateJustification${id}`,
      title: `Actualizar justificante para ${
        row.EmployeeLogsToEmployee.first_name
      } ${row.EmployeeLogsToEmployee.last_name} - ${moment(
        row.check_date
      ).format('dddd, D [de] MMMM [de] YYYY')}`,
      content: (
        <FormJustification
          item={row}
          setCloseModal={setCloseModal}
          getMinutesFunction={getMinutesFromDateTime}
          logId={id}
          justificationId={row.EmployeeLogsToJustification.id}
          refetchLogs={refetch}
        />
      ),
      size: 'large',
    })
  }

  const menuToExport = async () => {
    try {
      let periodo = 'month'
      const result = await MySwal.fire({
        title: 'Exportar Registros',
        html: `
          <div>
            <p>Seleccione un periodo o ingrese un rango de fechas personalizado:</p>
            <div style="display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
              <label><input type="radio" name="periodo" value="month" checked /> Mensual</label>
              <label><input type="radio" name="periodo" value="week" /> Semanal</label>
              <label><input type="radio" name="periodo" value="quincenal" /> Quincenal</label>
              <label><input type="radio" name="periodo" value="custom" /> Personalizado</label>
            </div>
            <div style="margin-top: 20px; display: flex; gap: 20px; justify-content: center;">
              <div>
                <label>Fecha inicio</label><br/>
                <input type="date" id="date_start" disabled />
              </div>
              <div>
                <label>Fecha fin</label><br/>
                <input type="date" id="date_end" disabled />
              </div>
            </div>
          </div>
        `,
        allowOutsideClick: false,
        buttonsStyling: false,
        showDenyButton: true,
        confirmButtonText: 'Aceptar',
        denyButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: 'StandarModalHtmlContainer',
          confirmButton: 'btn btn-orange',
          denyButton: 'btn StandarModalCancelButtonLogOut',
          footer: 'btn StandarModalFooterLogOut',
        },
        didOpen: () => {
          const radios = document.querySelectorAll('input[name="periodo"]')
          const dateStart = document.getElementById('date_start')
          const dateEnd = document.getElementById('date_end')

          radios.forEach((radio) => {
            radio.addEventListener('change', (e) => {
              periodo = e.target.value
              const isCustom = periodo === 'custom'
              dateStart.disabled = !isCustom
              dateEnd.disabled = !isCustom
            })
          })
        },
        preConfirm: () => {
          const dateStart = document.getElementById('date_start').value
          const dateEnd = document.getElementById('date_end').value

          if (periodo === 'custom' && (!dateStart || !dateEnd)) {
            Swal.showValidationMessage(
              'Debe seleccionar ambas fechas para rango personalizado'
            )
            return false
          }

          if (periodo === 'custom' && dateStart > dateEnd) {
            Swal.showValidationMessage(
              'La fecha de inicio no puede ser mayor que la fecha de fin'
            )
            return false
          }

          if (periodo === 'custom' && dateEnd < dateStart) {
            Swal.showValidationMessage(
              'La fecha de fin no puede ser menor que la fecha de inicio'
            )
            return false
          }

          if (periodo === 'custom' && !dateStart && !dateEnd) {
            Swal.showValidationMessage(
              'Debe seleccionar un rango de fechas personalizado'
            )
            return false
          }

          return {
            periodo,
            dateStart,
            dateEnd,
          }
        },
      })

      if (result.isConfirmed) {
        return {
          periodo: result.value.periodo,
          dateStart: result.value.dateStart,
          dateEnd: result.value.dateEnd,
        }
      }

      return null
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message || 'Ocurrió un error inesperado',
      })
    }
  }

  const handleExportAllLogs = async () => {
    try {
      const menu = await menuToExport()

      if (!menu) {
        return
      }

      console.log('Resultado del menú de exportación:', menu)

      if (menu) {
        showLoading()
        const { periodo, dateStart, dateEnd } = menu

        console.log('Periodo seleccionado:', periodo)
        console.log('Fecha inicio:', dateStart)
        console.log('Fecha fin:', dateEnd)

        let startDate = ''
        let endDate = ''

        switch (periodo) {
          case 'month':
            startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
            endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
            break
          case 'week':
            startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss')
            endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
            break
          case 'quincenal':
            const today = moment()

            const isFirstQuincena = today.date() <= 15

            const startOfQuincena = isFirstQuincena
              ? today.clone().startOf('month')
              : today.clone().date(16)

            const endOfQuincena = isFirstQuincena
              ? today.clone().date(15)
              : today.clone().endOf('month')

            startDate = startOfQuincena
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
            endDate = endOfQuincena.endOf('day').format('YYYY-MM-DD HH:mm:ss')
            break
          case 'custom':
            startDate = moment(dateStart)
              .startOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
            endDate = moment(dateEnd).endOf('day').format('YYYY-MM-DD HH:mm:ss')
            break
          default:
            throw new Error('Periodo no válido')
        }

        console.log('Fechas seleccionadas para exportación:')
        console.log('Fecha inicio:', startDate)
        console.log('Fecha fin:', endDate)

        const { data: exportData } = await exportAllLogs({
          variables: {
            filters: {
              start_date: startDate,
              end_date: endDate,
            },
          },
          fetchPolicy: 'no-cache',
        })

        const { exportEmployeeLogs } = exportData

        console.log('Datos a exportar:', exportEmployeeLogs)

        let dataToExport = exportEmployeeLogs.map((item) => {
          return {
            Empleado: item.employee,
            Entradas: item.punch_in,
            Salidas: item.punch_out,
            Retardos: item.lateness,
            Faltas: item.absences,
            'Salidas antes de hora': item.early_leave,
            Justificaciones: item.justfications,
          }
        })

        setExportationData({
          filename: `registros_empleados_${periodo}_${moment().format(
            'YYYYMMDD_HHmmss'
          )}.csv`,
          dataToExport,
        })

        return toastSweetAlert({
          mode: 'ok',
          message: 'Exportación realizada correctamente',
        })
      }
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message || 'Ocurrió un error inesperado',
      })
    } finally {
      hideLoading()
    }
  }

  const handleExportByEmployeeId = async (employeeId, row) => {
    try {
      const menu = await menuToExport()

      if (!menu) {
        return
      }
      showLoading()
      const { periodo, dateStart, dateEnd } = menu
      let startDate = ''
      let endDate = ''
      switch (periodo) {
        case 'month':
          startDate = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
          endDate = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'week':
          startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss')
          endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'quincenal':
          const today = moment()
          const isFirstQuincena = today.date() <= 15
          const startOfQuincena = isFirstQuincena
            ? today.clone().startOf('month')
            : today.clone().date(16)
          const endOfQuincena = isFirstQuincena
            ? today.clone().date(15)
            : today.clone().endOf('month')
          startDate = startOfQuincena
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
          endDate = endOfQuincena.endOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'custom':
          startDate = moment(dateStart)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss')
          endDate = moment(dateEnd).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
        default:
          throw new Error('Periodo no válido')
      }

      const { data: exportData } = await exportLogsByEmployeeId({
        variables: {
          employeeId: row.item__omit.employee_id,
          filters: {
            start_date: startDate,
            end_date: endDate,
          },
        },
        fetchPolicy: 'no-cache',
      })
      const { exportEmployeeByEmployeeId } = exportData

      let dataToExport = exportEmployeeByEmployeeId.map((item) => {
        return {
          Fecha: item.date,
          'Hora de entrada': item.hour_in,
          'Hora de salida': item.hour_out,
          'Retardo de entrada': item.lateness,
          Falta: item.absences,
          'Salida antes de hora': item.early_leave,
          'Estado del registro': item.status_log,
          Justificante: item.justification_type,
        }
      })

      setExportationData({
        filename: `registros_empleados_${employeeId}_${periodo}_${moment().format(
          'YYYYMMDD_HHmmss'
        )}.csv`,
        dataToExport,
      })
      return toastSweetAlert({
        mode: 'ok',
        message: 'Exportación realizada correctamente',
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message || 'Ocurrió un error inesperado',
      })
    } finally {
      hideLoading()
    }
  }
  return (
    <>
      <ContentHeader
        title=""
        breadcrumb=""
        windowTitle="Historial de Registros de Empleados"
      />
      <LayoutTable
        hideId
        title={'Historial de Registros de Empleados'}
        data={layoutInformation.dataTable}
        totalCount={layoutInformation.totalCount}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        detailsText={<i class="fas fa-eye"></i>}
        actionBtnDetails={handleDetails}
        editText={<i class="fas fa-file-download"></i>}
        actionBtnEdit={handleExportByEmployeeId}
        cols_search="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"
        cols_search_div="col-12"
        cols_filters="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-3 mt-3"
        cols_filters_div="col-12"
        isFilterRangeShow
        filterRangeProps={{
          from: {
            value: pagePagination.filters.start_date,
            id: 'start_date',
            // label: 'Fecha inicio',
          },
          to: {
            value: pagePagination.filters.end_date,
            id: 'end_date',
            // label: 'Fecha fin',
          },
          changeFilterDateRange: handleFiltersDateRange,
        }}
        filterChoosen={[
          {
            id: 'check_type',
            name: 'check_type',
            label: 'Tipo de registro',
            options: options.checkType,
            isClearable: true,
            isSearchable: true,
            placeholder: 'Seleccione un tipo de registro',
            onChange: (e) => handleFilters(e, 'check_type'),
          },
          {
            id: 'log_status',
            name: 'log_status',
            label: 'Estado del registro',
            options: options.logStatus,
            isClearable: true,
            isSearchable: true,
            placeholder: 'Seleccione un estado del registro',
            onChange: (e) => handleFilters(e, 'log_status'),
          },
        ]}
        exportOnClick={handleExportAllLogs}
        titleExportOnClick="Exportar"
        hideAddNew
      />

      <span
        id={`spanModal${modalContent.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modalContent.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModal}
      ></span>

      <ModalContent
        idModal={modalContent.modalId}
        title={modalContent.title}
        size={modalContent.size}
        onClose={() => {
          setCloseModal(true)
        }}
        content={modalContent.content}
      />

      <CSVLink
        id="exportLogsEmployees"
        data={exportationData.dataToExport}
        filename={exportationData.filename}
        className="d-none"
      ></CSVLink>
    </>
  )
}

export default EmployeesLogs
